import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PagamentoDespesaListarComponent } from './pagamento-despesa-listar.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: '', component: PagamentoDespesaListarComponent }
    ])],
    exports: [RouterModule]
})
export class PagamentoDespesaListarRoutingModule { }
